<div class="mainstepcontent row w100">
  <div class="leftside col grow-1 gap-24">
    <div class="col gap-16">
      <div class="col">
        <div class="stepcounter">
          STEP {{ thisStepCount }}/{{ totalStepCount }}
        </div>
        <h1>{{ step.stepTypeName }}</h1>
      </div>
      <div
        class="instructions align-center row gap-8 pointer"
        (click)="openInstructions()"
      >
        <rr-icon name="info"></rr-icon>
        <div class="underline">Instructions</div>
      </div>
    </div>
    <div class="secondary-text">
      Please answer the following questions to gain deeper insight into the core
      problem...
    </div>
    <div class="innerstep col">
      <h3 class="disabled" (click)="setStep(1)" *ngIf="activeStep !== 1">
        Let's experience a day with____
      </h3>
      <rr-ai-control
        *ngIf="activeStep === 1"
        text1="Let's experience a day with____"
        [control]="personaSelectionControl"
        (next)="nextStep()"
      ></rr-ai-control>
    </div>
    <div class="innerstep col" *ngFor="let item of aiResult; index as i">
      <h3 class="disabled" (click)="setStep(i)" *ngIf="activeStep !== i + 2">
        {{ item }}
      </h3>
      <rr-ai-control
        *ngIf="activeStep === i + 2"
        [text1]="item"
        [control]="aiResultControls[i]"
        (next)="nextStep()"
      ></rr-ai-control>
    </div>
  </div>
  <div class="rightside col gap-24">
    <div
      class="persona-image w100"
      [style.background]="
        persona?.image ? persona?.image : 'url(images/default-persona.png)'
      "
    ></div>
    <div class="persona-info">
      <div class="subtitle">Potential User</div>
      <div class="title">{{ persona.name }}</div>
    </div>
  </div>
</div>
<div class="footer row align-center">
  <div class="leftside row gap-16 align-center">
    <rr-btn type="Primary" [disabled]="nextBtnDisabledStatus">Next Step</rr-btn>
    <rr-btn type="Link" iconStart="arrow-left" size="medium">Back</rr-btn>
  </div>
  <div class="middle row grow-1 align-center justify-center">
    <div class="inner align-center row">
      <div class="stepcounter">
        STEP {{ thisStepCount }}/{{ totalStepCount }}
      </div>
      <rr-progress [progress]="progress"></rr-progress>
    </div>
  </div>
  <div class="rightside row gap-16 align-center">
    <rr-btn type="Secondary" size="Small" iconStart="upload"
      >Upload Knowledge</rr-btn
    >
    <rr-btn type="Secondary" size="Small" iconStart="add">Show Result</rr-btn>
  </div>
</div>
